import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import * as S from './styles'
import { convertDecimalCurrency } from '../../utils/utils'

const PedidoFinalizado = ({ type, pedidoId, valorST, operacao }) => {
  // const pedido = useSelector((store) => store.finalizado.pedido)
  // console.log(pedidoId)

  const pedidoConverted = pedidoId?.replace(/\D/gim, '')

  const popBoleto = () => {
    window.open(
      `${process.env.REACT_APP_URL_MAIN}/bradesco/gerarboleto/?idpedido=${pedidoConverted}`
    )
  }

  // const inicial = () => (window.location.href = process.env.REACT_APP_URL_MAIN)

  return (
    <>
      {!!type.includes('Boleto') && (
        <S.Wrapper>
          <S.Title>
            <h2>
              Pedido realizado
              <br />
              com sucesso
            </h2>
          </S.Title>

          <S.Info>
            <div>
              <h3>Obrigado por comprar no Gimba</h3>
            </div>

            <div>
              Você receberá um e-mail com a confirmação e todos os detalhes do
              seu pedido.
            </div>

            <div className="numero-pedido">
              Número do Pedido <br />
              <strong>
                <Link to={`/meus-pedidos/${pedidoConverted}`}>
                  {pedidoConverted}
                </Link>
              </strong>
            </div>

            {/* {valorST !== undefined && (
              <p className="cotacao-st">
                Sua {operacao === 'C' ? 'cotação' : 'negociação'} teve um
                acréscimo no valor. <br />
                Valor do ICSM - ST calculado: {convertDecimalCurrency(valorST)}
              </p>
            )} */}

            {type === 'Boleto à vista' && (
              <>
                <div className="boleto-visualizar">
                  Caso não consiga visualizar o boleto,{' '}
                  <div
                    onClick={() => popBoleto()}
                    style={{
                      textDecoration: 'underline',
                      fontWseight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    <strong>clique aqui</strong>
                  </div>
                </div>

                <div className="boleto-aviso">
                  O boleto é gerado automaticamente em uma nova janela.
                  Verifique se o seu navegador não esteja bloqueando POP-UP
                </div>
              </>
            )}
          </S.Info>

          <a href={process.env.REACT_APP_URL_MAIN}>
            <S.Button>Ir para Página Inicial</S.Button>
          </a>
        </S.Wrapper>
      )}

      {type === 'cartao' && (
        <S.Wrapper>
          <S.Title>
            <h2>
              Pedido realizado
              <br />
              com sucesso
            </h2>
          </S.Title>

          <S.Info>
            <div>
              <h3>Obrigado por comprar no Gimba</h3>
            </div>

            <div>
              Você receberá um e-mail com a confirmação e todos os detalhes do
              seu pedido.
            </div>

            <div className="numero-pedido">
              Número do Pedido <br />
              <strong>
                <Link to={`/meus-pedidos/${pedidoConverted}`}>
                  {pedidoConverted}
                </Link>
              </strong>
            </div>

            {/* {valorST !== undefined && (
              <p className="cotacao-st">
                Sua {operacao === 'C' ? 'cotação' : 'negociação'} teve um
                acréscimo no valor. <br />
                Valor do ICSM - ST calculado: {convertDecimalCurrency(valorST)}
              </p>
            )} */}
          </S.Info>

          <a href={process.env.REACT_APP_URL_MAIN}>
            <S.Button>Ir para Página Inicial</S.Button>
          </a>
        </S.Wrapper>
      )}
    </>
  )
}

export default PedidoFinalizado
